import type { ReactNode } from 'react';
import './Badge.css';

interface BadgeProps {
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md';
  children: ReactNode;
  className?: string;
  /** Hover text. A badge is usually a two-word summary of something longer —
   *  "same model", "3 differ" — so the explanation has to live somewhere, and
   *  a wrapper element just to carry it changes the layout around it. */
  title?: string;
}

export function Badge({
  variant = 'default',
  size = 'md',
  children,
  className = '',
  title,
}: BadgeProps) {
  return (
    <span className={`badge badge-${variant} badge-${size} ${className}`} title={title}>
      {children}
    </span>
  );
}
